module.exports = __webpack_public_path__ + "static/media/ua.a8b13525.svg";